import { LinkifyText } from "./LinkifyText";

## Basic Usage

<LinkifyText text="Check out https://example.com for more information." />

---

## Multiple URLs

<LinkifyText text="Visit https://github.com for code and https://docs.example.com for documentation." />

---

## Long URLs (Truncated)

<LinkifyText text="This is a very long URL: https://example.com/path/to/some/very/long/resource/that/exceeds/the/limit" />

URLs longer than 25 characters are truncated with an ellipsis.

---

## Various URL Formats

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <LinkifyText text="Simple: https://example.com" />
  <LinkifyText text="With www: https://www.example.com" />
  <LinkifyText text="Subdomain: https://app.example.com" />
  <LinkifyText text="With port: https://localhost:3000" />
  <LinkifyText text="With path: https://example.com/path/to/page" />
  <LinkifyText text="With query: https://example.com/search?q=test&page=1" />
</div>

---

## In Context

### Comment with Links

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem", maxWidth: "500px" }}>
  <div style={{ display: "flex", gap: "0.75rem", marginBottom: "0.5rem" }}>
    <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#e5e5e5" }} />
    <div>
      <div style={{ fontWeight: 500 }}>John Doe</div>
      <div style={{ fontSize: "12px", color: "#666" }}>2 hours ago</div>
    </div>
  </div>
  <LinkifyText text="Great article! I found more details at https://docs.example.com/guide and the source code is available at https://github.com/example/repo." />
</div>

### Chat Message

<div style={{ background: "#f5f5f5", borderRadius: "12px", padding: "0.75rem 1rem", maxWidth: "350px" }}>
  <LinkifyText text="Hey, check out this link: https://example.com/cool-feature - it has exactly what we need!" />
</div>

---

## Non-String Input

The component handles non-string inputs gracefully:

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <div>Empty: <LinkifyText text="" /></div>
  <div>Undefined: <LinkifyText text={undefined} /></div>
  <div>Plain text: <LinkifyText text="No URLs here, just plain text." /></div>
</div>

---

## Security Note

All links open in a new tab with `rel="noopener noreferrer"` for security:

<LinkifyText text="Secure external link: https://external-site.com/page" />


